import React from "react";

export const HeaderComponent = () => {
  return (
    <>
      <tmo-digital-header brand="metro" client-id='metro'></tmo-digital-header>
    </>
  );
};
